var h = Object.defineProperty;
var o = (i, t, e) => t in i ? h(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e;
var s = (i, t, e) => (o(i, typeof t != "symbol" ? t + "" : t, e), e);
class m {
  /**
   * Creates an instance of Marquee.
   * @param {HTMLElement} element - The DOM element that contains the marquee.
   * @param {Object} userConfig
   * @param {HTMLElement} userConfig.innerElement - The DOM element that represent the marquee text.
   * @param {HTMLElement} userConfig.textElement - The DOM element that represent the marquee text.
   * @param {boolean} [userConfig.pauseOnHover=false] - Whether to pause the animation on hover.
   * @param {boolean} [userConfig.autoStart=true] - Whether to start the animation automatically.
   * @param {number} [userConfig.speed=40] - The speed of the animation in pixel per seconds.
   * @param {string} [userConfig.blockClass='marquee'] - The class name of the marquee BEM-Block.
   * @memberof Marquee
   */
  constructor(t, e) {
    /**
     * Initializes the Marquee component by cloning the marquee text, setting up event bindings, and triggering the animation.
     */
    s(this, "init", () => {
      this.cloneTextToFillWidth(), this.duplicateInnerElement(), this.setDuration(), this.pauseOnHover && this.enablePauseOnHover(), this.bindEvents(), this.autoStart && this.enableAutoStart();
    });
    /**
     * Binds the necessary events for the Marquee component, such as load, visibility change, and resize.
     */
    s(this, "bindEvents", () => {
      document.addEventListener("visibilitychange", () => {
        this.element.classList.contains(this.stateClasses.isRunning) && (this.stop(), requestAnimationFrame(
          () => requestAnimationFrame(() => {
            this.start();
          })
        ));
      }), window.addEventListener("resize", () => {
        this.element.classList.contains(this.stateClasses.isRunning) && (this.stop(), this.setDuration(), requestAnimationFrame(
          () => requestAnimationFrame(() => {
            this.start();
          })
        ));
      });
    });
    /**
     * Calculates and sets animation duration based on the speed
     * and the width of the inner element.
     */
    s(this, "setDuration", () => {
      const t = this.innerElement.clientWidth;
      this.textElement.clientWidth, this._duration = t / this.speed, this.element.style.setProperty(
        "--animation-duration",
        `${this._duration}s`
      );
    });
    /**
     * When the marquee text is not long enough
     * we duplicated / clone it, until it is
     */
    s(this, "cloneTextToFillWidth", () => {
      const t = this.element.clientWidth, e = this.innerElement.clientWidth, l = Math.floor(t / e);
      for (let a = 0; a < l; a++) {
        const n = this.textElement.cloneNode(!0);
        n.classList.add(this.cloneClasses.textClone), n.setAttribute("aria-hidden", "true"), this.innerElement.appendChild(n);
      }
    });
    /**
     * We need the inner element to be duplicated
     * to show the start of the text while the end
     * is running out of the container
     */
    s(this, "duplicateInnerElement", () => {
      const t = this.innerElement.cloneNode(!0);
      t.classList.add(this.cloneClasses.innerClone), t.setAttribute("aria-hidden", "true"), this.element.appendChild(t);
    });
    /**
     * Enables the pause on hover functionality
     */
    s(this, "enablePauseOnHover", () => {
      this.element.classList.add(this.stateClasses.hasPauseOnHover);
    });
    s(this, "enableAutoStart", () => {
      this.start(), window.addEventListener("load", () => {
        this.stop(), requestAnimationFrame(
          () => requestAnimationFrame(() => {
            this.start();
          })
        );
      });
    });
    /**
     * Starts the animation.
     *
     * @public
     */
    s(this, "start", () => {
      this.element.classList.add(this.stateClasses.hasAnimation), this.element.classList.add(this.stateClasses.isRunning);
    });
    /**
     * Stops the animation (-> and also resets it).
     *
     * @public
     */
    s(this, "stop", () => {
      this.element.classList.remove(this.stateClasses.hasAnimation), this.element.classList.remove(this.stateClasses.isRunning);
    });
    /**
     * Pauses the animation.
     *
     * @public
     */
    s(this, "pause", () => {
      this.element.classList.remove(this.stateClasses.isRunning);
    });
    /**
     * Toggle the animation.
     *
     * @public
     */
    s(this, "toggle", () => {
      this.element.classList.toggle(this.stateClasses.isRunning);
    });
    /**
     * Destroys the animation.
     *
     * @public
     * @todo Fully clean up the DOM.
     */
    s(this, "destroy", () => {
      this.element.classList.remove(this.stateClasses.hasAnimation), this.element.classList.remove(this.stateClasses.isRunning), this.element.style.removeProperty("--animation-duration");
    });
    this.element = t, this.blockClass = e.blockClass || "marquee", this.innerElement = e.innerElement || this.element.querySelector(`.${this.blockClass}__inner`), this.textElement = e.textElement || this.element.querySelector(`.${this.blockClass}__text`), this.pauseOnHover = e.pauseOnHover || !1, this.autoStart = e.autoStart || !0, this.speed = e.speed || 40, this.stateClasses = {
      isRunning: `${this.blockClass}--is-running`,
      hasAnimation: `${this.blockClass}--has-animation`,
      hasPauseOnHover: `${this.blockClass}--has-pause-on-hover`
    }, this.cloneClasses = {
      innerClone: `${this.blockClass}__inner-clone`,
      textClone: `${this.blockClass}__text-clone`
    }, this._duration = null;
  }
}
export {
  m as Marquee
};
